import { styled } from "styled-components";
import { mobileBreakPointCSS } from "../../defaults/theme.js";
import { buttonReset } from "../../util/styles.js";

export const Heading = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${(props) => props.theme.spacing.m};
  margin-bottom: ${(props) => props.theme.spacing.m};

  > * {
    margin: 0;
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    margin: ${(props) => props.theme.spacing.xl} 0;
  }
`;

export const Content = styled.div`
  @media (min-width: ${mobileBreakPointCSS}) {
    display: flex;
    gap: ${(props) => props.theme.spacing.l};
  }
`;

export const Menu = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  width: 260px;

  li {
    margin-bottom: ${(props) => props.theme.spacing.l};

    a {
      text-decoration: none;
      color: inherit;
    }
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-auto-rows: 166px;
  grid-gap: ${(props) => props.theme.spacing.s};

  @media (min-width: ${mobileBreakPointCSS}) {
    grid-auto-rows: 214px 300px 214px 338px;
    grid-template-columns: repeat(12, 1fr);
    grid-gap: ${(props) => props.theme.spacing.l};
  }
`;

export const Card = styled.a<{ $image: string }>`
  display: block;
  background-image: ${(props) => `url(${props.$image})`};
  background-size: cover;
  background-position: center;
  height: 100%;
  border-radius: ${(props) => props.theme.borderRadius};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  overflow: hidden;
  text-decoration: none;

  h3 {
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
    margin: 0;
    padding: 0 ${(props) => props.theme.spacing.xs};
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    grid-column: span 6;

    &:nth-child(8n + 3) {
      grid-column: span 12;
    }

    &:nth-child(8n + 6),
    &:nth-child(8n + 7),
    &:nth-child(8n + 8) {
      grid-column: span 4;
    }
  }
`;

export const ModalWrapper = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 100vw;
  background-color: #fff;
  color: var(--swatch2);
  padding: ${(props) => props.theme.spacing.l};
  max-height: 100vh;
  overflow-y: auto;

  h1 {
    margin: ${(props) => props.theme.spacing.m} 0;
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    padding: ${(props) => `${props.theme.spacing.xl} ${props.theme.spacing.l}`};
  }
`;

export const ModalClose = styled.button`
  ${buttonReset}
  padding: ${(props) => props.theme.spacing.s};
  width: auto;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;

  svg {
    display: block;
    width: 16px;
    height: 16px;
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    padding: ${(props) => props.theme.spacing.l};

    svg {
      width: 24px;
      height: 24px;
    }
  }
`;

export const ModalNav = styled.div`
  display: flex;
  justify-content: space-between;
  margin: ${(props) => props.theme.spacing.m} 0;

  .next {
    margin-left: auto;
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    margin: ${(props) => `0 0 ${props.theme.spacing.xl}`};
  }
`;

export const ModalContent = styled.div`
  @media (min-width: ${mobileBreakPointCSS}) {
    display: flex;
    gap: ${(props) => props.theme.spacing.xl};
  }
`;

export const GalleryGrid = styled.div`
  display: grid;
  grid-auto-rows: auto;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: ${(props) => props.theme.spacing.xs};
  margin-bottom: ${(props) => props.theme.spacing.l};

  a,
  img {
    display: block;
    border-radius: ${(props) => props.theme.borderRadius};
  }

  img {
    width: 100%;
  }

  > :first-child {
    grid-column: span 4;
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    width: 644px;
    margin-bottom: 0;
    grid-gap: ${(props) => props.theme.spacing.s};
  }
`;

export const ModalText = styled.div`
  flex: 1;
`;
